import BaseActionTypes from "../../base/BaseActionTypes";

const HashTagActionTypes = {
  ...BaseActionTypes("hashtag"),
};

export default HashTagActionTypes;
